import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import API from "../../actions";
import "./Newsletter.css";
import moment from "moment";

const Newsletter = props => {
    const history = useHistory();
    const [therapists, setTherapists] = useState([]);
    const [newsletter, setNewsletter] = useState(false);
    const [trial, setTrial] = useState(false);

    useEffect(() => {
        (async () => {
            await setTherapists(await API.adminGetTherapists(localStorage.getItem("adminToken")));
            const t = await API.adminGetTherapists(localStorage.getItem("adminToken"));
            console.log(t);
        })();
    }, []);

    if (!therapists) {
        return <div></div>;
    }
    return (
        <div>
            {async event => {
                event.preventDefault();
                localStorage.setItem("adminToken", "");
                history.push("/admin");
            }}

            <button
                onClick={event => {
                    event.preventDefault();
                    localStorage.clear();
                    history.push("/admin");
                }}>
                Log Ud
            </button>
            <h2> Kunder der vil have tilsendt Nyhedsbreve </h2>
            <button
                onClick={() => {
                    setNewsletter(true);
                    setTrial(false);
                }}>
                Tilmeldte
            </button>
            <button
                onClick={() => {
                    setNewsletter(false);
                    setTrial(false);
                }}>
                Alle
            </button>
            <button
                onClick={() => {
                    setNewsletter(false);
                    setTrial(true);
                }}>
                Trial
            </button>
            <table>
                <tr>
                    <th> Firmanavn </th>
                    <th> Fornavn </th>
                    <th> Efternavn </th>
                    <th> Mailadresse </th>
                    <th> Oprettelsesdato </th>
                </tr>
                {therapists.map((therapist, i) =>
                    (newsletter && therapist.newsletter) || (trial && therapist.trial) || (!trial && !newsletter) ? (
                        <tr>
                            <td>{therapist.companyName}</td>
                            <td>{therapist.nameFirst} </td>
                            <td>{therapist.nameLast}</td>
                            <td> {therapist.email}</td>
                            <td> {moment(new Date(therapist.createdAt)).format("DD-MM-YYYY")}</td>
                        </tr>
                    ) : (
                        <></>
                    )
                )}
            </table>
        </div>
    );
};

export default Newsletter;
